import { createSlice } from '@reduxjs/toolkit';
import { getItemTypes, getPricingPoints, getRescalingSupportedItemTypes } from './itemApi';
import mappedItemTypes from 'services/items/mappedItemTypes';

const initialState = {
    itemTypes: [],
    dataForItemCreation: [],
    rescalingSupportedItemTypes: [],
    itemTypesWithWeatherZones: [mappedItemTypes.WIND_ASSET.id],
};

const itemSlice = createSlice({
    name: 'items',
    initialState,
    reducers: {},
    extraReducers: {
        [getItemTypes.fulfilled]: (state, action) => {
            state.itemTypes = action.payload;
        },
        [getPricingPoints.fulfilled]: (state, action) => {
            state.dataForItemCreation = action.payload;
        },
        [getRescalingSupportedItemTypes.fulfilled]: (state, action) => {
            state.rescalingSupportedItemTypes = action.payload;
        },
    },
});

export default itemSlice.reducer;
